<template>
  <div class="report-check">
    <div class="data-content">
        <Modal
          @on-ok="awardProcess()"
          title="请选择发放的奖励"
          v-model="modal1"
          :closable="false"
          :mask-closable="false"
        >
          <div class="modal1-div">
            <span>奖励类型：</span>
            <Select
              v-model="awardType"
              clearable
              size="small"
              style="min-width: 300px; width:30%"
            >
              <Option
                v-for="item in filterOption.feedbackAwardList"
                :value="item.value"
                :key="item.value"
              >
                {{
                item.label }}
              </Option>
            </Select>
            <div class="modal1-div" style="margin-top: 10px;"><pre>历史记录：<br>{{awardRecordContent}}</pre></div>
          </div>
        </Modal>
        <Modal
          @on-ok="typeProcess()"
          title="请选择切换的类型"
          v-model="typeSelected"
          :closable="false"
          :mask-closable="false"
        >
          <div class="modal1-div">
            <span>类型：</span>
            <Select
              v-model="currentType"
              clearable
              size="small"
              style="min-width: 300px; width:30%"
            >
              <Option
                v-for="item in filterOption.feedbackTypeList"
                :value="item.value"
                :key="item.value"
              >
                {{
                item.label }}
              </Option>
            </Select>
          </div>
        </Modal>
        <Modal
          v-model="modalAdd"
          title="IM消息回复"
          :closable="false"
          :mask-closable="false"
          @on-ok="addRecord"
        >
          <div class="add-item">
            <span>发送内容：</span>
            <Input
              class="input"
              type="textarea"
              :rows="4"
              v-model="content"
              placeholder="请输入发送内容"
              clearable
            />
          </div>
        </Modal>
      <div class="table-head">
        <div class="table-title">
          <span style="font-weight: bold">反馈记录</span>
        </div>
        <div class="filter-head">
            <div class="filter-item" style="width: 120px; margin-right: 10px;">
              <Select v-model="filterData.feedback_platform" clearable style="min-width: 80px;">
                <Option
                  v-for="item in filterOption.feedbackPlatform"
                  :value="item.value"
                  :key="item.value"
                >
                  {{item.label }}
                </Option>
              </Select>
            </div>
            <div class="filter-item" style="width: 140px; margin-right: 10px;">
                <Input
                    v-model="filterData.feedback_app_version"
                    maxlength="20"
                    placeholder="版本号(如:5.7.2)"
                    clearable/>
            </div>
            <div class="filter-item" style="width: 140px; margin-right: 10px;">
                <Input
                    v-model="filterData.feedback_search_key"
                    maxlength="20"
                    placeholder="关键字(两字以上)"
                    clearable/>
            </div>
            <div class="filter-item-datetime" style="margin-right: 10px;">
              <DatePicker
                @on-change="changeDate"
                v-model="filterOption.datetime"
                type="datetimerange"
                format="yyyy/MM/dd HH:mm"
                placeholder="选择时间"
                style="min-width: 280px; width:90%"
              ></DatePicker>
            </div>
            <div class="filter-item" style="width: 120px; margin-right: 10px;">
              <Select v-model="filterData.feedback_type" clearable style="min-width: 80px;">
                <Option
                  v-for="item in filterOption.feedbackTypeList"
                  :value="item.value"
                  :key="item.value"
                >
                  {{item.label }}
                </Option>
              </Select>
            </div>
           <div class="filter-item" style="width: 120px; margin-right: 10px;">
             <Select v-model="filterData.feedback_handle_status" clearable style="min-width: 80px">
               <Option
                 v-for="item in filterOption.feedbackHandleStatusList"
                 :value="item.value"
                 :key="item.value"
               >
                 {{item.label }}
               </Option>
             </Select>
           </div>
          <Button @click="pageOption.page = 1,getData()">搜索</Button>
        </div>
      </div>
      <Table :show-header ="false" :columns="columns" :data="changeDataList" @on-selection-change="selected">
        <template slot-scope="{ row, index }" slot="datetime">
          <div class="avatar">
              <Poptip trigger="hover" :transfer="true" title="图片详情">
                    <div class="info-pop" slot="content">
                        <img :src="row.avatar" class="img-avatar-preview">
                    </div>
                    <img :src="row.avatar" class="img-avatar">
              </Poptip>
          </div>
          <div class="report-content">
              <div class="user-nickname">{{ row.nickname }}</div>
              <div class="user-created-at">{{ row.created_at }}</div>
              <div class="user-invite-code">身份ID：{{ row.invite_code }}</div>
              <div class="user-contact-info">联系方式：{{ row.contact_info }}</div>
              <div class="report-bottom">
                  <div class="report-desc">{{ row.content }}</div>
                  <div class="report-img-container">
                     <span v-for="item of getImageList(row)" class="report-img">
                         <Poptip trigger="hover" :transfer="true" title="图片详情">
                               <div class="info-pop" slot="content">
                                   <img :src="item" style="height: 400px;">
                               </div>
                               <img :src="item" class="report-image">
                         </Poptip>
                     </span>
                  </div>
                  <div class="report-type">
                    <span>{{ row.device_info }}</span> 
                  </div>
                  <div>
                    <Button
                      type="error"
                      size="large"
                      :disabled="row.disable_process"
                      style="margin-right: 20px"
                      @click="reportProcessButton(row,2)"
                    >处理</Button>
                    <Button
                      type="success"
                      size="large"
                      :disabled="row.disable_cancel"
                      style="margin-right: 20px"
                      @click="reportProcessButton(row,0)"
                    >忽略</Button>
                    <Button
                      type="warning"
                      size="large"
                      :disabled="row.disable_wait"
                      style="margin-right: 20px"
                      @click="reportProcessButton(row,1)"
                    >待处理</Button>
                    <Button
                      :disabled="row.disable_award"
                      type="primary"
                      size="large"
                      style="margin-right: 20px"
                      v-show = "row.type != 2"
                      @click="awardProcessButton(row,true)"
                    >发放奖励</Button>
                    <Button
                      type="success"
                      size="large"
                      style="margin-right: 20px"
                      v-show = "row.handle_status != 2"
                      @click="typeProcessButton(row,0)"
                    >切换类型</Button>
                    <Button
                      type="success"
                      size="large"
                      style="margin-right: 20px"
                      v-show = "row.type == 0 && row.handle_status != 2"
                      @click="typeProcessNew(row,1)"
                    >产品建议</Button>
                    <Button
                      type="success"
                      size="large"
                      style="margin-right: 20px"
                      v-show = "row.type == 0 && row.handle_status != 2"
                      @click="typeProcessNew(row,2)"
                    >使用建议</Button>
                    <Button
                      type="primary"
                      size="large"
                      v-show = "row.type == 2"
                      @click="addRecordProcessButton(row,0)"
                    >回复</Button>
                  </div>
              </div>
          </div>
        
         
        </template>
      </Table>
      <div class="text-center" style="margin-top: 10px;" v-show="dataList.length != 0">
        <Page
          show-elevator
          :page-size="pageOption.page_size"
          :total="pageOption.total"
          @on-change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import apis from "../../http/api";
import commonApi from "../../utils/commonapi.js";

export default {
  name: "ReportCheck",
  components: {},
  watch: {
  },
  data() {
    return {
      filterOption: {
        datetime: [],
        feedbackPlatform:[{'label':'全部','value':'全部'},{'label':'Android','value':'Android'},{'label':'iOS','value':'iOS'}],
        feedbackTypeList:[{'label':'bug反馈','value':0},{'label':'产品建议','value':1},{'label':'使用建议','value':2}],
        feedbackHandleStatusList:[{'label':'未处理','value':-1},{'label':'忽略','value':0},{'label':'待处理','value':1},{'label':'已处理','value':2}],
        feedbackAwardList:[{'label':'合理建议或接近bug：388Co币 ','value':1},{'label':'良好建议或有效bug：888Co币','value':2},{'label':'优秀建议或重大bug：1388Co币','value':3}],
      },
      filterData: {
        datetime: ["", ""],
        feedback_type:0,
        feedback_handle_status:-1,
        feedback_platform:'全部',
        feedback_search_key:"",
        feedback_app_version:"",
      },
      selectedItem: [],
      selectedId: [],
      dataList: [],
      columns: [
        {
            title: '举报记录',
            slot: 'datetime',
            sortable: true
        }
      ],
      pageOption: {
        page_size: 10,
        total: 100,
        page: 1
      },
      currentRow: {},
      modal1:false,
      currentType:0,
      typeSelected:false,
      modalAdd: false,
      awardType:1,
      awardRecordContent:"暂无",
      content: '',
    }
  },
  created() {
    this.getData();
  },
  methods: {
    pageChange(page) {
      this.pageOption.page = page;
      this.getData()
    },
    test(index) {
      console.log(index)
    },
    changeDate() {
      if (this.filterOption.datetime) {
        console.log(this.filterOption.datetime)
        if (this.filterOption.datetime[0] !== "") {
          this.filterData.datetime = [
            this.$moment(this.filterOption.datetime[0]).format("YYYY-MM-DD HH:mm:ss"),
            this.$moment(this.filterOption.datetime[1]).format("YYYY-MM-DD HH:mm:ss")
          ];
        }else{
            this.filterData.datetime = ["",""];
        }
      }
    },
    getData() {
      var platform =''
      if(this.filterData.feedback_platform!="全部"){
          platform = this.filterData.feedback_platform
      }
      let params = {
        page: this.pageOption.page -1,
        page_size: this.pageOption.page_size,
        type: this.filterData.feedback_type,
        handle_status: this.filterData.feedback_handle_status,
        start_date: this.filterData.datetime[0],
        end_date: this.filterData.datetime[1],
        platform:platform,
        app_version:this.filterData.feedback_app_version,
        search_keyword:this.filterData.feedback_search_key

      };
      apis.feedback_get_options(params).then(res => {
        const { data, errCode, msg } = res;
        if (errCode === 0) {
          this.pageOption.total = data.count;
          this.dataList = data.records;
        }
      }).catch(err => {
        console.error('接口异常', err);
        alert('接口异常');
      })
    },
    selected(selecttion) {
      this.selectedId = [];
      this.selectedItem = selecttion;
      selecttion.forEach(item => {
        this.selectedId.push(item.id)
      })
      console.log(this.selectedId)
    },
    // 处理按钮
    reportProcessButton(row,process) {
     
     let post_data = {
       record_id: row.id,
       handle_status: process,
     };
     if(process == 2){
         var isNext = confirm("是否继续处理？")
         if(isNext){
           apis.feedback_process(post_data).then(res => {
             const { data, errCode, msg } = res;
             if (errCode === 0) {
               // 记录-反馈-处理
               commonApi.recordFromOperationFeedback(0, this.filterOption.feedbackHandleStatusList, process, row.id, '')
               this.$nextTick(() => {
                 this.getData()
               });
             } else {
               alert(msg)
             }
           }).catch(err => {
             alert('接口异常')
           })
         }
     }else {
        apis.feedback_process(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
            // 记录-反馈-忽略、待处理
            commonApi.recordFromOperationFeedback(0, this.filterOption.feedbackHandleStatusList, process, row.id, '')
            this.$nextTick(() => {
              this.getData()
            });
          } else {
            alert(msg)
          }
        }).catch(err => {
          alert('接口异常')
        })
     }
    },
    // 处理按钮
    awardProcessButton(row,process) {
        this.currentRow = row
        this.awardType = 1
        this.getAwardRecord()
        this.modal1 = true
    },
    awardProcess(){
       let post_data = {
         record_id: this.currentRow.id,
         award_level: this.awardType,
       };
        var isNext = confirm("是否继续处理？")
        if(isNext){
          apis.feedback_award(post_data).then(res => {
            const { data, errCode, msg } = res;
            if (errCode === 0) {
              // 记录-反馈-发放奖励
              commonApi.recordFromOperationFeedback(1, this.filterOption.feedbackAwardList, this.awardType, this.currentRow.id, '发放奖励：')
              this.$nextTick(() => {
                this.getData()
              });
            } else {
              alert(msg)
            }
          }).catch(err => {
            alert('接口异常')
          })
        } 
    },
    getAwardRecord(){
        let post_data = {
          user_id: this.currentRow.user_id,
        };
        apis.feedback_user_award_record(post_data).then(res => {
          const { data, errCode, msg } = res;
          if (errCode === 0) {
              this.awardRecordContent = data['content']
          } else {
            alert(msg)
          }
        }).catch(err => {
         
        })
    },
    // 处理按钮
    typeProcessButton(row,process) {
        this.currentRow = row
        this.currentType = this.currentRow.type
        this.typeSelected = true
    },
    typeProcess(){
       let post_data = {
         record_id: this.currentRow.id,
         type: this.currentType,
       };
       apis.feedback_update(post_data).then(res => {
         const { data, errCode, msg } = res;
         if (errCode === 0) {
           // 记录-反馈-切换类型
           commonApi.recordFromOperationFeedback(2, this.filterOption.feedbackTypeList, this.currentType, this.currentRow.id, '切换类型：')
           this.$nextTick(() => {
             this.getData()
           });
         } else {
           alert(msg)
         }
       }).catch(err => {
         alert('接口异常')
       })
    },
    typeProcessNew(row,type){
       this.currentRow = row
       let post_data = {
         record_id: this.currentRow.id,
         type: type,
       };
       apis.feedback_update(post_data).then(res => {
         const { data, errCode, msg } = res;
         if (errCode === 0) {
           // 记录-反馈-切换类型
           commonApi.recordFromOperationFeedback(2, this.filterOption.feedbackTypeList, this.currentType, this.currentRow.id, '切换类型：')
           this.$nextTick(() => {
             this.getData()
           });
         } else {
           alert(msg)
         }
       }).catch(err => {
         alert('接口异常')
       })
    },
    addRecordProcessButton(row,process) {
        this.currentRow = row
        this.modalAdd = true
    },
    addRecord() {
      let post_data = {
        // 0信使小Co,1小co
        from_user_type: 1,
        msg: this.content,
        user_id: this.currentRow.user_id
      }
      apis.feedback_send_single_message(post_data).then(res => {
        const { data, errCode, msg } = res
        if (errCode === 0) {
          this.$Message.success('发送成功！')
          // 记录-反馈-回复
          commonApi.recordFromOperationFeedback(3, null, 0, this.currentRow.id, "回复："+this.content)
          this.content = ''
        }else {
          alert(msg)
        }
      }).catch(res => {
        console.log(res)
      })
    },
    getImageList(row) {
      var images =row.images
      for (var i=0;i< images.length;i++) {
          images[i] = "https://image.co-study.com.cn/app/image/feedback/"+ images[i]
      }
      return images
    },
  },
  computed: {
    changeDataList() {
      return this.dataList.map(item => {
        // 创建 item 的副本，避免直接修改原始数据
        const newItem = Object.assign({}, item);
        
        var avatar = newItem['avatar']
        if(avatar == undefined || avatar == ""){
            avatar = "webco.png"
        }
        if(avatar.startsWith("http")){
            
        }else{
            newItem['avatar'] = "https://image.co-study.com.cn/app/image/avatar/"+ avatar
        }
        
        // 联系方式
        if(newItem['contact_info'] == undefined || newItem['contact_info'] == ""){
             newItem['contact_info'] = "未填写"
        }
        if(newItem['content'] == undefined || newItem['content'] == ""){
             newItem['content'] = "未填写"
        }
        if(newItem['type'] == 1){
            newItem['content'] = "产品建议：" + newItem['content']
        }else if(newItem['type'] == 2){
            newItem['content'] = "使用建议：" + newItem['content']
        }else{
            newItem['content'] = "bug描述：" + newItem['content']
        }
        var isDisable = newItem['handle_status'] === 2 || newItem['handle_status'] === 0
        newItem['disable_process'] = isDisable
        newItem['disable_cancel'] = isDisable
        newItem['disable_wait'] = isDisable || newItem['handle_status'] === 1
        // 已经发放过，或类型为使用建议的不可发放奖励
        newItem['disable_award'] = newItem['award_level'] >= 0 || newItem['type'] == 2
        return newItem
      })
    }
  },
  filters: {
    change_report_info(val) {
      let itemList = val.split('\n');
      let newList = itemList.map(item => {
        if (item.length > 10) {
          return item.slice(0, 9) + "..."
        } else {
          return item
        }
      });
      return newList.slice(0, 2).join('\n')
    }
  }
}
</script>

<style scoped>
.report-check {
  margin: 10px;
}

.filter-head {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.filter-item {
  min-width: 80px;
  width: 12%;
  margin: 0 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.filter-item-datetime {
  min-width: 280px;
  /*width: 10%;*/
  margin: 0 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/*.filter-item p {*/
/*    text-align: center;*/
/*}*/
.clickable-span {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}

.report-info {
  font-size: xx-small;
  white-space: pre-wrap; /* \n换行 */
}

.text-center {
  text-align: center;
}

.table-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 5px;
}

.table-title {
  align-self: center;
}

.modal1-div {
  margin-bottom: 10px;
}

.info-pop {
  white-space: pre-wrap;
}

.avatar{
    float: left;
    width: 50px;
    margin-top: 20px;
}
.img-avatar{
    width: 50px;
    height: 50px;
    border-radius: 50%;
}
.img-avatar-preview{
    width: 400px;
    height: 400px;
}
.report-content{
    float: left;
    width: 750px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 20px;
}
.user-nickname{
    font-weight: bold;
    float: left;    
    font-size: 16px;
    width: 500px;
    color: #000000;
}
.user-created-at{
    font-weight: normal;
    font-size: 16px;
    float: right;
    color: #cccccc;
}
.user-invite-code{
    font-weight:bold;
    float: left;
    font-size: 14px;
    margin-top: 8px;
    width: 120px;
    color: #cccccc;
}
.user-contact-info{
    font-weight: normal;
    font-size: 14px;
     margin-top: 8px;
    float: right;
    color: #cccccc;
}
.report-bottom{
    float: left;
    margin-top: 8px;
    width: 750px;
}
.report-desc{
    font-weight:normal;
    font-size: 16px;
    color: #000000;
}
.report-img-container{
    margin-top: 20px;
}
.report-img{
    margin-right: 20px;
}
.report-image{
   width: 80px;
   height: 80px; 
}
.report-type{
    font-weight: bold;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 10px;
    color: #000000;
}

</style>
